import React from "react";

export type TArrawRightIconProps = React.SVGAttributes<SVGElement>;

export function ArrawRightIcon({ ...rest }: TArrawRightIconProps) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53608 7.00004L-5.62024e-08 12.7142L1.24568 14L8 7.02836L7.97256 7.00004L8 6.97172L1.24568 
          8.57762e-05L-5.55753e-07 1.28585L5.53608 7.00004Z"
        fill="#7F94A1"
      />
    </svg>
  );
}
